import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'capq-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent {
  constructor(@Inject(DOCUMENT) public document: Document) {}

  navigateHome() {
    document.location.href = document.location.origin;
  }
}
